<template>
  <div class="end-settlement">
    <div class="end-settlement_greeting flex-column justify-center">
      <div class="encourage-label"><span>恭喜！</span>完成本次阅读理解训练</div>
      <div class="greeting-emoji">
        <img
          class="greeting-emoji_bg"
          :src="getBrandImageUrl('ai_smart_reading/end_exercise_fireworks.png')"
          alt=""
        />
        <img
          class="greeting-emoji_image"
          :src="getBrandImageUrl('ai_smart_reading/end_exercise_happy.png')"
          alt=""
        />
      </div>
      <div class="settle-text flex-column justify-evenly">
        <div class="next-text">解锁下一篇，添加知识点<br />至打印页面</div>
        <ion-button class="end-exercise" shape="round" @click="endTheExercise">返回首页</ion-button>
        <div
          class="create-forgetfulness text-center common-color mt-3 cursor-pointer"
          @click="createForgettable"
        >
          结束并创建抗遗忘
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { actionSheetController, IonButton, modalController } from "@ionic/vue";
import http from "@/js/http";
import store from "@/js/store";
import { useRoute, useRouter } from "vue-router";
import { defineProps, onBeforeUnmount, ref } from "vue";
import { openMsgToast } from "@/views/AIGenerate/openModal";
import { useCurrentStepStore } from "@/hooks/useCurrentStepStore";
import { getBrandImageUrl } from "@/js/brandImages";

const props = defineProps(["readingId", "fromPrepareOrigin"]);
const router = useRouter();
const route = useRoute();
const studentInfo = ref();
const stepStore = useCurrentStepStore();

async function endTheExercise() {
  if (!props.fromPrepareOrigin) {
    await finishReadingArticleLearning();
  }
  stepStore.initStepNum();
  stepStore.control3SecondsVisible();
  store.clearStudentInfoSession();
  await modalController
    .dismiss()
    .then()
    .catch((e) => console.log(e));
  await modalController
    .dismiss()
    .then()
    .catch((e) => console.log(e));
  await modalController
    .dismiss()
    .then()
    .catch((e) => console.log(e));
  await modalController
    .dismiss()
    .then()
    .catch((e) => console.log(e));
}

//结束一篇文章的练习
async function finishReadingArticleLearning() {
  const appointment = store.getAppointment();
  await http.post("/reading/finishReadingArticleLearning", {
    readingId: props.readingId,
    studentId: appointment.studentId,
    aptmId: appointment.aptmId,
  });
}

async function showTeacherSelect(aptmId: any) {
  if (!props.fromPrepareOrigin) {
    await finishReadingArticleLearning();
  }
  return new Promise((resolve, reject) => {
    let buttons = [];
    for (let i = 5; i < 24; i++) {
      let fill = i < 10 ? "0" : "";
      let time1 = fill + i + ":00";
      let time2 = fill + i + ":30";
      let params1 = { aptmId: aptmId, startTime: time1 };
      let params2 = { aptmId: aptmId, startTime: time2 };
      buttons.push({
        text: time1,
        handler: async () => {
          if (props.fromPrepareOrigin) { // 备课模式下，直接结束练习
            await openMsgToast("21天抗遗忘创建成功。");
            await modalController.dismiss({ type: "TEXT" });
            resolve("");
            return;
          }
          requestGenerateForget(params1)
            .then(() => {
              resolve("");
            })
            .catch((e) => {
              reject(e);
            });
        },
      });

      buttons.push({
        text: time2,
        cssClass: "teacherSelectButtons",
        handler: () => {
          if (props.fromPrepareOrigin) { // 备课模式下，直接结束练习
            openMsgToast("21天抗遗忘创建成功。");
            modalController.dismiss({ type: "TEXT" });
            resolve("");
            return;
          }
          requestGenerateForget(params2)
            .then(() => {
              resolve("");
            })
            .catch((e) => {
              reject(e);
            });
        },
      });
    }

    actionSheetController
      .create({
        header: "选择抗遗忘时间",
        buttons: buttons,
      })
      .then((actionSheet) => {
        actionSheet.present();
      })
      .catch((e) => {
        reject(e);
      });
  });
}

function requestGenerateForget(params: any) {
  return new Promise((resolve: any) => {
    http.post("/forget/generateForget", params).then(async (res: any) => {
      if (res.data.success) {
        await openMsgToast("21天抗遗忘创建成功。");
        await modalController.dismiss({ type: "TEXT" });
        resolve();
      }
    });
  });
}

async function createForgettable() {
  stepStore.initStepNum();
  const appointment = store.getAppointment();
  await showTeacherSelect(appointment.aptmId);
  store.clearStudentInfoSession();
  store.setStudentId(appointment.studentId);
  localStorage.setItem("appointment", JSON.stringify(appointment));
}

onBeforeUnmount(() => {});
</script>

<style scoped lang="less">
@import "@/assets/common.less";

.end-settlement {
  width: 100%;
  height: 100%;
  position: relative;

  &_greeting {
    position: absolute;
    bottom: 50%;
    left: 0;
    width: 100%;
    height: 100%;
    color: #ffffff;
    font-weight: 600;
    text-align: center;
    letter-spacing: 2px;
    font-size: 4vw;

    .encourage-label {
      font-size: var(--font-20);

      span {
        color: #e8486d;
        font-size: var(--font-20);
      }
    }

    .greeting-emoji {
      position: relative;
      width: 100%;
      height: 100%;

      &_image {
        position: absolute;
        top: 40%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 55%;
      }

      &_bg {
        position: absolute;
        top: 0;
        left: 50%;
        transform: translate(-50%, 0);
        width: 100%;
      }
    }

    .settle-text {
      position: absolute;
      top: 70%;
      left: 0;
      width: 100%;
      height: 70%;
    }

    .next-text {
      font-size: 2.5vw;
      color: #742438;
      font-weight: 700;
      line-height: 1.5rem;
      text-align: center;
    }

    .end-exercise {
      width: 70%;
      margin: 0 auto;

      &::part(native) {
        font-size: 2.2vw;
        background: linear-gradient(90deg, #ea4b36 0%, #e74772 100%);
        --box-shadow: none;
        padding: 4vw 9vw;
      }
    }

    .create-forgetfulness {
      font-size: 2.2vw;
      font-weight: 600;
    }
  }
}
</style>
